module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAH1JREFUSA1jfK2g/p9hEAKmQegmsJMGrcNYmKWlBmWgMf4HgsHoskEblYPWYSxnT18fjDHJwKgi4zeaxkiJmkGbxkYdRko0gtSOhhipIcaSmhlIqh66qB+tK0kN5kGb+Fm+1jeT6hm6qGccbfOTGM6DN43ddvddRaJn6KIcACv1FfNjRLK2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Thailand.png
// module id = 493
// module chunks = 7